import React from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';
import * as S from './styles';

const InfoBarItem = ({ label, value, isLocal }) => {
  const { data: match } = useSelector(state => state.matches.selectedMatch);
  return (
    <S.InfoBarItem isLocal={isLocal}>
      <S.InfoBarItemLabel isLocal={isLocal} competition={match?.competitionId}>
        {label}
      </S.InfoBarItemLabel>
      <S.InfoBarItemValue isLocal={isLocal}>{value || '-'}</S.InfoBarItemValue>
    </S.InfoBarItem>
  );
};

InfoBarItem.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isLocal: PropTypes.bool,
};

InfoBarItem.defaultProps = {
  label: '',
  value: '',
  isLocal: false,
};

export default InfoBarItem;
